import Thai from './th.json'
import English from './en.json'

const langs = [
  {
    code: 'en',
    name: 'English',
    messages: English
  },
  {
    code: 'th',
    name: 'ภาษาไทย',
    messages: Thai
  },
];

export default langs;